export function slugToTitle(slug:String) {
    return slug
        .split('-') // Split the slug into words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' '); // Join words with space to form the title
}

export function getLastSlug(url:String) {
    const pathParts = url.split('/')
    const filteredParts = pathParts.filter(part => part.length > 0)
    return filteredParts.pop() || ''
}

export function breakDownUrl(path:String) {
    const pathSegments = path.split('/').filter(segment => segment !== '');
    const paths = [];
    for (let i = pathSegments.length; i > 0; i--) {
        const path = '/' + pathSegments.slice(0, i).join('/');
        paths.push(path);
    }
    return paths;
}

export function breadcrumbsFromURL(path:String) {
    const pathSegments = path.split('/').filter(segment => segment !== '');
    const paths = [];
    for (let i = pathSegments.length; i > 0; i--) {
        const path = '/' + pathSegments.slice(0, i).join('/');
        paths.push({ name: slugToTitle(getLastSlug(path)), item: path  });
    }
    paths.sort((a, b) => a.item.length - b.item.length);
    return paths;
}

export function getMapFromExceptionsList(reservedUrlExceptions) {
    const exceptionsMap = reservedUrlExceptions.reduce((acc, item) => {
        acc[item.path] = item.model;
        return acc;
    }, {});
    return exceptionsMap
}